import { styled } from '@mui/material/styles';
import { Card as BaseCard } from 'components/cards';

export const Card = styled(BaseCard)(() => ({
  minHeight: '200px'
}));

export const EmptySection = styled('div')(({ theme }) => ({
  border: `1px dashed ${theme.color.grey[500]}`,
  borderRadius: theme.borderRadius.base,
  boxSizing: 'border-box',
  padding: theme.spacing(3)
}));

export const EmptyText = styled('p')(() => ({
  lineHeight: '1.5em',
  margin: 0
}));
